import { update } from '@/features/firebase/adapter/database'
import FirebaseDatabaseRefService from '@/features/firebase/services/database-ref'
import { Notification } from '@/features/notifications/notification-service-extension-shared/types/app'

export const updateFirebaseReadNotifications = async (
    notification: Notification
): Promise<void> => {
    await update(FirebaseDatabaseRefService.readNotifications(), {
        [notification.id]: notification.createdAt,
    })
}
